var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { WordingGuess } from './WordingGuess';
import { isNumericString } from '../../../../utils/helper/helper_string';
import { runtime } from '../../../../classes/runtime/Runtime';
import { sortByFunc } from '../../../../utils/helper/lodash_replacements';
export class WordingHear {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get wording() {
        return this.parent;
    }
    get wordTask() {
        return this.wording.wordTask;
    }
    get latestPhrase() {
        if (!runtime.availablePackages.Exotic)
            return undefined;
        // if (!this.wordTask.context.app.aural) return undefined;
        return this.wordTask.context.app.aural.auralPhrases.latestPhrase;
    }
    get filteredGuesses() {
        if (!this.latestPhrase)
            return [];
        const guesses = this.latestPhrase.guesses;
        if (this.wording.inputComparer.parseExpect.isCleanedExpectedStringANumber) {
            return guesses.filter(guess => isNumericString(guess.transcript));
        }
        return guesses;
    }
    get wordingGuesses() {
        return this.filteredGuesses.map(guess => new WordingGuess(this.wording, guess));
    }
    get bestWordingGuess() {
        if (runtime.isServerRuntime)
            return undefined;
        const comparers = this.wordingGuesses
            .concat()
            .sort(sortByFunc((item) => item.guessComparer.overallSimilar.averageAlgorithmSimilarity))
            .reverse();
        const bestComparer = comparers[0];
        return bestComparer;
    }
}
__decorate([
    computed
], WordingHear.prototype, "wordingGuesses", null);
__decorate([
    computed
], WordingHear.prototype, "bestWordingGuess", null);
